import { IxGenericTree } from './IxGenericTree.js';

window.customElements.define('ix-generic-tree', IxGenericTree);
